//
//

/* eslint-disable */
import editor from "vue2-ace-editor";
import "brace/mode/javascript";
import "brace/mode/text";
import "brace/mode/json";
import "brace/mode/xml";
import "brace/theme/tomorrow";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import FabricInput from "@/components/q-fabric-input.vue";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        AQModal,
        AQCard,
        FabricInput,
        editor,
        AQTooltip
    },
    filters: {
        ellipsis(error) {
            if (error.length > 110) {
                return `${error.substr(0, 110)}...`;
            }
            return error;
        }
    },
    props: {
        jsonViewParsed: String,
        instName: String,
        lastUpDate: String,
        lastUpUsername: String,
        dataModelClassIds: Array,
        dataModelData: Array,
        instanceID: String
    },
    data() {
        return {
            editor: [],
            nrOfErrors: null,
            errorsArray: [],
            hasErrors: false,
            jsonToSend: "",
            instanceName: this.$t("liveView.taskDescription.instanceName"),
            titleModal: this.$t(
                "admin.processInspector.dataModelModal.modalTitle"
            ),
            PIDataModelModal: true,
            isDisabled: true,
            hasCancel: false,
            hasClose: true,
            initialValue: null
        };
    },
    computed: {
        ...mapGetters("admin", ["getProcessInspectorById"]),
        saveBtn() {
            return { label: this.$t("admin.processInspector.dataModelModal.save"), disabled: this.isDisabled };
        },
        computedErrors() {
            return this.hasErrors ? this.errorsArray : null;
        },
        localJson: {
            get() {
                return this.jsonViewParsed;
            },
            set(v) {
                this.jsonToSend = v;
                this.canSave();
            }
        }
    },
    methods: {
        ...mapActions("admin", ["dataModelSave"]),
        canSave() {
            this.initialValue = this.jsonViewParsed;
            if (this.jsonToSend && this.jsonToSend !== this.initialValue) {
                this.isDisabled = false;
            } else {
                this.isDisabled = true;
            }
        },
        actionsDlg($event) {
            if ($event === "save") {
                this.errorsArray = [];
                if (this.nrOfErrors) {
                    const errorLine = document.getElementsByClassName("ace_line");
                    Object.keys(errorLine).forEach(key => {
                        if (
                            errorLine[key].style
                            && errorLine[key].style.backgroundColor
                        ) {
                            errorLine[key].style.backgroundColor = "";
                        }
                    });
                }
                this.sendJSONForValidation();
                this.$emit("actionDone");
            } else if ($event === "close") {
                this.$emit("input", false);
            }
        },
        atEditorInit(editorInstance) {
            this.editor = editorInstance;
        },
        sendJSONForValidation() {
            const payload = { data: [] };
            const dataToSendObj = {};
            const editorErrors = this.editor.getSession().getAnnotations();
            const editorHasErrors = editorErrors.some(
                elem => elem.type === "error"
            );

            if (!editorHasErrors) {
                if (!this.jsonToSend) {
                    this.jsonToSend = this.jsonViewParsed;
                }
                Object.entries(JSON.parse(this.jsonToSend)).forEach(
                    ([key, value], index) => {
                        dataToSendObj.type = key;
                        if (this.dataModelData) {
                            const item = this.dataModelData.find(elem => elem.type === key);
                            if (item) {
                                dataToSendObj.id = item.id;
                            }
                        } else {
                            dataToSendObj.id = this.dataModelClassIds[index];
                        }
                        dataToSendObj.fields = JSON.stringify(value);
                        const cloneObj = { ...dataToSendObj };
                        payload.data.push(cloneObj);
                    }
                );
                payload.processInstanceId = this.getProcessInspectorById.rootProcessInstanceId;
                this.dataModelSave(payload).then(data => {
                    if (data.status === 200) {
                        this.$emit("refreshJson", true);
                        this.hasErrors = false;
                        this.nrOfErrors = null;
                        this.$emit("input", false);
                        this.$toast.showNotify({
                            type: "success",
                            message: this.$t("admin.processInspector.dataModelModal.savedSuccessfully")
                        });
                    } else if (data.response && data.response.status === 406) {
                        const classItem = document.getElementsByClassName(
                            "ace_line"
                        );
                        const validationErrorList = data.response.data.validationErrorList.concat(
                            data.response.data.structureErrorList
                        );
                        this.hasErrors = true;
                        this.nrOfErrors = data.response.data.validationErrorList.length
                            + data.response.data.structureErrorList.length;

                        validationErrorList.forEach(error => {
                            for (let key in classItem) {
                                const errorClass = error.modelClass.split(".");
                                if (
                                    classItem[key]
                                    && classItem[key].innerText
                                ) {
                                    if (
                                        classItem[key].innerText
                                            .trim()
                                            .replace(/"/g, "")
                                        === `${errorClass[0]}: {`
                                    ) {
                                        if (classItem[key]) {
                                            while (classItem[key]) {
                                                if (error.valueEntered) {
                                                    if (
                                                        classItem[key].innerText
                                                            .trim()
                                                            .replace(/"/g, "")
                                                            .includes(
                                                                `${error.modelField
                                                                }: ${
                                                                    error.valueEntered}`
                                                            )
                                                    ) {
                                                        classItem[
                                                            key
                                                        ].style.backgroundColor = "rgba(255, 0, 0, 0.1)";
                                                        break;
                                                    }
                                                } else {
                                                    const structuralError = classItem[
                                                        key
                                                    ].innerText
                                                        .trim()
                                                        .replace(/"/g, "")
                                                        .split(":");
                                                    if (
                                                        structuralError[0]
                                                        === error.modelField
                                                    ) {
                                                        classItem[
                                                            key
                                                        ].style.backgroundColor = "rgba(255, 0, 0, 0.1)";
                                                        break;
                                                    }
                                                }
                                                key++;
                                            }
                                            break;
                                        }
                                    }
                                }
                            }
                        });
                        validationErrorList.forEach(error => {
                            this.errorsArray.push(
                                `${error.modelClass
                                }.${
                                    error.modelField
                                } - ${
                                    error.errorDescription}`
                            );
                        });
                    } else {
                        this.hasErrors = true;
                    }
                });
            } else {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("admin.processInspector.dataModelModal.savedUnsuccessfully")
                });
            }
        }
    }
};
